var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.dataTabs),function(tab){
var _obj;
return _c('li',{key:tab.value,staticClass:"tabs-item",class:( _obj = {selected: tab.value === _vm.selectedValue}, _obj[_vm.classPrefix+ '-tabs-item'] = _vm.classPrefix, _obj ),on:{"click":function($event){return _vm.select(tab)}}},[_vm._v(_vm._s(tab.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }